import React from 'react'
import { chartColors } from 'components/charts/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Container, Spinner,
} from 'reactstrap'
import { gql, useQuery } from '@apollo/client'
import { Query } from 'generated/types'
import { Card, CardBody, CardTitle } from './ChartCard'
import { useFilters } from './FiltersContext'
import BusiestSpaceChartDetails from './BusiestSpaceChartDetails'

const CHECKIN_COUNT_BY_SPACE = gql`
  query CheckinCountBySpace($limit:Int, $startDate: DateTime!, $endDate: DateTime!) {
    chart {
      checkinCountBySpace(limit: $limit, filters: { startDate: $startDate, endDate: $endDate }) {
          count
          space {
            id
            name
            capacity
          }
      }
    }
  }
`

const BusiestSpacesCard: React.FC = ({ children }) => {
  return (
    <Card className="mb-3">
      <CardBody className="rounded-soft">
        <CardTitle className="mb-2">Busiest Spaces</CardTitle>
        {children}
      </CardBody>
    </Card>
  )
}

export const BusiestSpaces: React.FC = () => {
  const [filters] = useFilters()
  const { data, loading, error } = useQuery<Query>(CHECKIN_COUNT_BY_SPACE, {
    variables: {
      limit: 5,
      startDate: filters.startDate?.toJSDate(),
      endDate: filters.endDate?.toJSDate(),
    },
  })

  if (loading) {
    return (
      <BusiestSpacesCard>
        <Spinner color="light" />
      </BusiestSpacesCard>
    )
  }

  if (error) {
    return (
      <BusiestSpacesCard>
        <div className="d-flex justify-content-center">
          <FontAwesomeIcon
            icon="exclamation-triangle"
            color={chartColors.medium}
            transform="grow-30"
            className="mt-3"
          />
        </div>
        <div className="mt-4 text-center fs--1">
          <p>There was an error fetching the data</p>
        </div>
      </BusiestSpacesCard>
    )
  }

  const counts = data?.chart.checkinCountBySpace || []

  return (
    <BusiestSpacesCard>
      <Container>
        {counts.map((c) => <BusiestSpaceChartDetails space={c.space} count={c.count} />)}
      </Container>
    </BusiestSpacesCard>
  )
}
